import { ReactElement, InputHTMLAttributes } from "react";
import { SpaceProps } from "styled-system";

export const scales = {
  SM: "sm",
  MD: "md",
  LG: "lg",
} as const;

export type Scales = typeof scales[keyof typeof scales];

export interface InputProps extends InputHTMLAttributes<HTMLInputElement>, SpaceProps {
  scale?: Scales;
  isSuccess?: boolean;
  isWarning?: boolean;
  display?: string;
  alignItems?: string;
  padding?: string;
  children?: import('react').ReactNode;
  ref?: any;
}

export interface InputGroupProps extends SpaceProps {
  scale?: Scales;
  startIcon?: ReactElement;
  endIcon?: ReactElement;
  children: ReactElement;
}
